import React from 'react';
import config from '../../config';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';

const shareButtonsIcons = [
  faLink, faLinkedinIn, faYoutube
];

library.add(...shareButtonsIcons);
export default function SocialLinks({ sectionP=true, links = config.socialLinks}) {
  let socialLinks = links.map(social => {
      const { icon, url } = social;
      return (
        <a key={url} href={url} target="_blank" className={`mx-2`}>
          <FontAwesomeIcon icon={icon} />
        </a>
      );
    });
  
  return (
    sectionP?<section className="social-section bg-fg">
      <div className="social d-flex justify-content-center">
        {socialLinks}
      </div>
    </section> : socialLinks
  );
}
